import { render, staticRenderFns } from "./businessArea.vue?vue&type=template&id=4cb352d7&scoped=true&"
import script from "./businessArea.vue?vue&type=script&lang=js&"
export * from "./businessArea.vue?vue&type=script&lang=js&"
import style0 from "./businessArea.vue?vue&type=style&index=0&id=4cb352d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb352d7",
  null
  
)

export default component.exports